import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {
  Aangifte,
  AangifteBerekening,
  AangifteRapport, BokkzAlgDataService, Box2Berekening, IncomeTaxEntity,
  OpbouwBox2,
  SpecificatieInkomenBox2
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { AbstractControl, FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import {BehaviorSubject, filter, Subscription} from "rxjs";
import { Event, NavigationEnd, Router } from "@angular/router";
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-overzicht-inkomen-box2',
  templateUrl: './overzicht-inkomen-box2.component.html',
  styleUrls: ['./overzicht-inkomen-box2.component.scss'],
  imports: [
    ReactiveFormsModule,
    SharedUiDetailsModule,
    SharedUiFormControlsModule,
    CommonModule
  ]
})
export class OverzichtInkomenBox2Component implements OnInit, OnDestroy {
  private routerSubscription: Subscription | undefined;
  private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
  private isSaving = false;
  public aangifte = {} as Aangifte;
  public incomeTaxEntity = {} as IncomeTaxEntity;
  public clientId!: string;
  @Input() partner = new BehaviorSubject<boolean>(false);
  public partnerBoolean = {} as boolean;
  public specInkomenBox2FormGroup = this.fb.group<AangifteRapport>({});
  public specInkomenBox2 = {} as AangifteRapport;
  public berekeningFormGroup = this.fb.group<AangifteBerekening>({});
  public berekeningPartnerFormGroup = this.fb.group<AangifteBerekening>({});
  public berekening = {} as AangifteBerekening;
  public berekeningPartner = {} as AangifteBerekening;
  public hasVerdelingGezien = false;

  constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService,
              private router: Router,
              private fb: FormBuilder) {
    this.specInkomenBox2FormGroup = this.fb.group<AangifteRapport>(({
      specificatieInkomenBox2: this.fb.group<SpecificatieInkomenBox2>(({
        opbouw: this.fb.group<OpbouwBox2>(({
          inkomenUitAanmerkelijkBelang: null as unknown as number,
          verrekendVerlies: null as unknown as number,
          saldoAanmerkelijkBelang: null as unknown as number,
          inkomenNaVerlies: null as unknown as number,
          aandeelPartner: null as unknown as number,
          verrekendVerliesPartner: null as unknown as number,
          inkomenNaVerliesPartner: null as unknown as number
        } as OpbouwBox2)),
      } as SpecificatieInkomenBox2)),
      specificatieBox2: this.fb.group<SpecificatieInkomenBox2>(({
        opbouw: this.fb.group<OpbouwBox2>(({
          reguliereVoordelen: null as unknown as number,
          fictieveReguliereVoordelen: null as unknown as number,
          vervreemdingsVoordelen: null as unknown as number,
          verkrijgingsPrijs: null as unknown as number,
          aftrekbareKosten: null as unknown as number,
        } as OpbouwBox2))
      } as SpecificatieInkomenBox2))
    } as AangifteRapport));
    this.berekeningFormGroup = this.fb.group<AangifteBerekening>(({
      box2: this.fb.group<Box2Berekening>(({
        inkomen: null as unknown as number,
        persoonsgebondenAftrek: null as unknown as number,
        belastbaarInkomen: null as unknown as number,
        inkomstenbelasting: null as unknown as number,
        conserverendeAanslag: null as unknown as number,
        opbouwInkomen: this.fb.group<OpbouwBox2>(({
          inkomenUitAanmerkelijkBelang: null as unknown as number,
          verrekendVerlies: null as unknown as number,
          saldoAanmerkelijkBelang: null as unknown as number,
        } as OpbouwBox2)),
      } as Box2Berekening)),
    } as AangifteBerekening));
    this.berekeningPartnerFormGroup = this.fb.group<AangifteBerekening>(({
      partnerBerekening: this.fb.group<AangifteBerekening>(({
        box2: this.fb.group<Box2Berekening>(({
          inkomen: null as unknown as number,
          persoonsgebondenAftrek: null as unknown as number,
          belastbaarInkomen: null as unknown as number,
          inkomstenbelasting: null as unknown as number,
          conserverendeAanslag: null as unknown as number,
          opbouwInkomen: this.fb.group<OpbouwBox2>(({
            inkomenUitAanmerkelijkBelang: null as unknown as number,
            verrekendVerlies: null as unknown as number,
            saldoAanmerkelijkBelang: null as unknown as number,
          } as OpbouwBox2)),
        } as Box2Berekening)),
      } as AangifteBerekening)),
    } as AangifteBerekening));
  }

  public ngOnInit(): void {
    this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
      this.incomeTaxEntity = incomeTaxEntity;
      if (incomeTaxEntity.aangifte) {
        this.aangifte = incomeTaxEntity.aangifte as Aangifte;
        this.dataService.aangifteRapport.subscribe((value) => {
          this.specInkomenBox2 = value;
          this.specInkomenBox2FormGroup.patchValue(this.specInkomenBox2)
        });
        this.dataService.aangifteBerekening.subscribe((value) => {
          this.berekening = value;
          this.berekeningFormGroup.patchValue(this.berekening)
          this.berekeningPartner = value;
          this.berekeningPartnerFormGroup.patchValue(this.berekeningPartner)
        });
        this.disableFormGroup(this.specInkomenBox2FormGroup);
        this.disableFormGroup(this.berekeningFormGroup);
        this.disableFormGroup(this.berekeningPartnerFormGroup);
      }
    });
    this.partner.subscribe((partner) => {
      this.partnerBoolean = partner
    });
    this.routerSubscription = this.router.events
      .pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {this.handleUrlChange(event.urlAfterRedirects);});
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
    }
    if (this.incomeTaxEntitySubscription) {
      this.incomeTaxEntitySubscription.unsubscribe();
    }
    if (this.clientEntitySubscription) {
      this.clientEntitySubscription.unsubscribe();
    }
  }

  handleUrlChange(newUrl: string) {
    if (!this.isSaving && this.hasUnsavedChanges()) {
      this.isSaving = true;
      this.dataService.postIncomeTaxEntity(this.clientId,false, this.incomeTaxEntity);
      this.isSaving = false;
    }
  }

  private hasUnsavedChanges(): boolean {
    return this.specInkomenBox2FormGroup.dirty
  }

  disableFormGroup(formGroup: FormGroup | AbstractControl): void {
    if (formGroup instanceof FormGroup) {
      Object.keys(formGroup.controls).forEach((key) => {
        const control = formGroup.get(key);
        if (control instanceof FormControl) {
          control.disable();
        } else if (control instanceof FormGroup) {
          this.disableFormGroup(control);
        }
      });
    }
  }
}
